import { uniq } from 'lodash';

import { CarrierModel } from '@/lib/models/carrier/types';
import { RouteScheduleInterface } from '@/types';
import { CarrierTypes } from '@/types/api-types';
import { getCarrierName } from '@/utils/carrier';
import { getPreferredIdentifier } from '@/utils/helpers';
import { getCarrierType } from '@/utils/helpers/search-filters';

interface CarrierOption {
  label: string;
  value: string;
  type: CarrierTypes;
}

export const getScheduleCarriers = (schedules: RouteScheduleInterface[]) => {
  const carrierIds = schedules.reduce((acc, schedule) => {
    const scheduleCarrierIds = schedule.attributes.primaryCarriers;
    return [...acc, ...scheduleCarrierIds];
  }, [] as string[]);

  // Remove duplicates
  return uniq(carrierIds);
};

export const getCarrierOptions = (carriers: CarrierModel[]): CarrierOption[] => {
  return carriers.map((carrier) => {
    const preferredIdentifier = getPreferredIdentifier(carrier.identifiers);

    const carrierName = getCarrierName(carrier);

    const value = carrier.id || '';
    const carrierType = getCarrierType(preferredIdentifier);

    return {
      label: carrierName,
      value,
      type: carrierType,
      id: preferredIdentifier?.value,
    };
  });
};
